import { useEffect } from 'react';
import { useColumnFilterRegistryContext } from '../context/useColumnFilterRegistryContext';

// Enter applies the column filter from anywhere while the overlay is open. Skips multi-line/date controls (they own Enter), the Clear button (let its native click run), and already-handled events (e.g. reference popover).
export const useColumnFilterApplyShortcut = (columnName: string) => {
  const { applyColumnFilter } = useColumnFilterRegistryContext();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Enter' || event.defaultPrevented) return;

      const target = event.target as HTMLElement | null;
      if (
        target?.closest(
          'textarea, .p-datepicker, .p-timepicker, .rdp, .react-datepicker'
        )
      )
        return;
      if (target?.closest('.column-filter-clear-button')) return;

      event.preventDefault();
      applyColumnFilter(columnName);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [applyColumnFilter, columnName]);
};
